import formReducer from '../formsReducer'

const formName = 'orders/status'

export default formReducer(formName)
